/* @flow */
import PropTypes from 'prop-types';
import * as React from 'react';
import shallowCompare from 'react-addons-shallow-compare';

import CurrentUser from 'auth/CurrentUser';
import Glyph from 'components/Glyph';
import LayerTrigger from 'components/LayerTrigger';
import Menu from 'components/Menu';
import MenuItem from 'components/MenuItem';
import Message from 'entities/Message';
import openPopup from 'utils/openPopup';

import GroupMessageBase from './GroupMessageBase';
import GroupMessageContent from './GroupMessageContent';
import GroupMessageHeader from './GroupMessageHeader';
import GroupMessageInformation from './GroupMessageInformation';

const UI_CONTEXT = 'group_message';

class GroupMessage extends React.Component<Object, $FlowFixMeState> {
  static propTypes = {
    backgroundColor: PropTypes.string,
    border: PropTypes.bool,
    showReadReceipt: PropTypes.bool,
    iconUrl: PropTypes.string,
    message: PropTypes.instanceOf(Message).isRequired,
    groupId: PropTypes.number,
    groupIsOwnedByUser: PropTypes.bool,
  };

  static childContextTypes = {
    eventContextName: PropTypes.string,
  };

  static defaultProps = {
    border: true,
    iconUrl: null,
    showReadReceipt: true,
  };

  getChildContext() {
    return {
      eventContextName: UI_CONTEXT,
    };
  }

  shouldComponentUpdate(nextProps: Object, nextState: Object) {
    // 'message' never changes deeply, but it may get a new object even when
    // nothing changes. So this is safe, but not maximally performant.
    return shallowCompare(this, nextProps, nextState);
  }

  tweet = () => {
    const { message } = this.props;

    let text = message.getBody();
    message.getFiles().forEach(file => {
      const fileUrl = file.getUrls().large || file.getUrls().cdn;
      text += ' ' + fileUrl;
    });
    text += ' (via remind.com)';

    const encodedText = encodeURIComponent(text);
    const url = `https://twitter.com/intent/tweet?text=${encodedText}`;

    openPopup(url, 'twitter');
  };

  renderHeaderActions = () => {
    const menu = (
      <Menu>
        {!CurrentUser.getUser().isUnderage() && (
          <MenuItem onClick={() => this.tweet()}>Tweet</MenuItem>
        )}
      </Menu>
    );

    return (
      <div className="GroupMessageBase-headerActions">
        <LayerTrigger layer={menu} trigger="click" placement="bottom" alignment="middle">
          <Glyph color="koala" name="ellipses" size="large" solo />
        </LayerTrigger>
      </div>
    );
  };

  render() {
    const { message } = this.props;
    return (
      <GroupMessageBase
        className="GroupMessage"
        message={this.props.message}
        border={this.props.border}
        backgroundColor={this.props.backgroundColor}>
        <GroupMessageHeader
          ref="header"
          author={message && message.getSender().getName()}
          initials={message && message.getSender().getInitials()}
          senderId={message && message.getSender().id}
          iconUrl={this.props.iconUrl}>
          {this.props.groupIsOwnedByUser && this.renderHeaderActions()}
        </GroupMessageHeader>
        <GroupMessageContent />
        <GroupMessageInformation message={message} showReadReceipt={this.props.showReadReceipt} />
      </GroupMessageBase>
    );
  }
}

export default GroupMessage;
